export default __webpack_public_path__ + "static/highlight-3-mobile-d95a06173fd79b9032883fcd6dbe897e.svg";